module.exports = __webpack_public_path__ + "img/ariel-welcome.a5b66f96.png";